'use strict';

exports.__esModule = true;
var _lodash = require('lodash');
var _errors = require('./errors');
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Reducer = function () {
  function Reducer(options) {
    _classCallCheck(this, Reducer);
    this.initialState = options.initialState;
    this.listenTo = options.listenTo;
    if ((0, _lodash.isUndefined)(this.initialState)) {
      throw new _errors.NoInitialStateGiven();
    }
    if (!(0, _lodash.isObject)(this.listenTo) || (0, _lodash.isEmpty)(this.listenTo)) {
      throw new _errors.NoListenToGiven();
    }
  }
  Reducer.prototype.build = function build() {
    var _this = this;
    return function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? _this.initialState : arguments[0];
      var action = arguments[1];
      return _this.hasHandler(action) ? _this.listenTo[action.type].call({
        state: state,
        action: action
      }, state, action) : state;
    };
  };
  Reducer.prototype.hasHandler = function hasHandler(action) {
    return (0, _lodash.isObject)(action) && this.listenTo.hasOwnProperty(action.type);
  };
  return Reducer;
}();
exports.default = Reducer;